import React from "react";
import StatusGuestsList from "../StatusGuestsListComponent/StatusGuestsListComponent";


const ParticipationConfirmed = () => {
  return (
    <div className="pendingGuestsPage">
      <StatusGuestsList
        statusFilter="Participation Confirmed"
        showMobileWhatsApp={true}
      />
    </div>
  );
};

export default ParticipationConfirmed;